// Cast intent builders (server-authoritative cast pipeline, P5-cast-move). Each
// returns a `{ domain:'cast', kind, ... }` object the server's match:intent
// handler routes into castService. The server VALIDATES hard cast legality
// (owner-lock + positional restriction) and commits zone + position + mana in
// one atomic diff. Keep payload shapes in lockstep with
// valkenhall-server/src/match/castService.js.

// Play a permanent (Minion / Artifact / Aura / Site) into the realm at a cell.
// W3: the mana debit is SERVER-computed (printed cost through the server-owned
// EffectLedger breakdown). `manaCost` is legacy-ignored. `autoPay: false`
// opts the cast out of the automated debit (manual mana management, or a
// client-consumed Apex free-cast window).
export function castPlayIntent(cardId, seat, { col, row, x, z, manaCost = 0, faceDown, autoPay } = {}) {
  const intent = { domain: 'cast', kind: 'play', cardId, seat, toZone: 'play', col, row, x, z, manaCost, faceDown };
  if (autoPay === false) intent.autoPay = false;
  return intent;
}

// Cast a Magic. It never enters the realm; it routes to the storyline (then on
// to the cemetery). No board cell.
export function castMagicIntent(cardId, seat, { manaCost = 0 } = {}) {
  return { domain: 'cast', kind: 'play-magic', cardId, seat, toZone: 'storyline', manaCost };
}

// Cast the CURRENT TOP of the caster's spellbook to a cell (Cradle of
// Etherrum's standing "cast Dragons from the top here for (1) less"). The
// server validates the card IS the deck top + a standing grant source sits at
// the cell, and PRICES the debit itself (printed + costDelta, floor 0). The
// client never asserts this cost.
export function castFromDeckTopIntent(cardId, seat, { col, row, x, z } = {}) {
  return { domain: 'cast', kind: 'play', fromDeckTop: true, cardId, seat, toZone: 'play', col, row, x, z, manaCost: 0 };
}
